module.exports = __webpack_public_path__ + "static/media/app icon (4).ba5d0cae.png";